import { connect, ConnectedProps } from 'react-redux';

import {
  selectors as tenantDataSelectors,
  actions as tenantDataActions,
} from 'src/redux/data/tenant';
import {
  actions as siteGroupsDataActions,
  selectors as siteGroupsDataSelectors,
} from 'src/redux/data/siteGroups';
import { apiStatusEnum } from 'src/utils/constants';
import { selectors as operatorsSelectors } from 'src/redux/data/operators';
import { selectors as customersSelectors } from 'src/redux/data/customers';
import { DATA_FETCHING_STATUS } from 'src/redux/data/constants';
import { API_STATUS } from 'src/utils/api-constants';
import { RootState } from 'src/redux/store';

const mapStateToProps = (state: RootState) => ({
  sitesList: tenantDataSelectors.getAddTenantsParentList(state),
  currentSiteGroupData: siteGroupsDataSelectors.getCurrentSiteGroups(state),
  isLoading:
    siteGroupsDataSelectors.getCurrentSiteGroupsStatus(state) ===
      apiStatusEnum.LOADING ||
    operatorsSelectors.selectOperatorsListStatus(state) ===
      apiStatusEnum.LOADING ||
    customersSelectors.selectCustomersListStatus(state) ===
      DATA_FETCHING_STATUS.LOADING ||
    tenantDataSelectors.getAddTenantsParentListStatus(state) ===
      API_STATUS.LOADING,
});

const mapActionCreators = {
  getAddTenantsParentList: tenantDataActions.getAddTenantsParentList,
  getCurrentSiteGroupData: siteGroupsDataActions.getCurrentSiteGroups,
  setCurrentSiteGroups: siteGroupsDataActions.setCurrentSiteGroups,
};

const Connector = connect(mapStateToProps, mapActionCreators);
export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
